import React,{ useContext,useState,useEffect} from "react";
import AllCourcesStyle from "./AllCourcesStyle.module.css";
import axios from "axios";
//import material  ui
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
//import contexts
import { CartContext} from '../../../context/CartContextProvider'
import { AuthContext} from '../../../context/AuthContextProvider'

//impport image
import image from "../../../assets/products/google.png";
//import components
import {ButtonError,Button} from '../../../components/UI/Button'
import {isInCart} from '../../../helper/functions'
//Link
import { Link,useNavigate } from "react-router-dom";
const AllCources = () => {
  const navigate = useNavigate();
  //states
  const [Cources,setCources]= useState([]);
//useEffect
useEffect(()=>{
  const getData = async () => {
    const response = await axios.get(
      "https://academy-nyctophile.herokuapp.com/api/term/getall"
    );
    setCources(response.data.result);
  };
  getData();
},[])
  //constext
  const {state,dispatch}=useContext(CartContext);
  const authContext=useContext(AuthContext)
  return (
    <>
      <h2 style={{ marginTop: "10px", textAlign: "center", color: "#f9f9f9" }}>
        تمام دوره ها
      </h2>
{authContext.isAuth ?       <div className={AllCourcesStyle.grid}>
      {Cources.map((cources) => (
        <div className={AllCourcesStyle.card}>
          <Card sx={{ maxWidth: 345 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={
                require(`../../../assets/products/${cources.course.image}`)
                  .default
              }
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                {cources.title}
              </h2>
              <h3
                style={{
                  textAlign: "right",
                  color: "orange",
                  fontSize: "16px",
                }}
              >
                ظرفیت:
                <span
                  style={{
                    color: "#475960",
                    marginRight: "3px",
                    textDecoration: "underline",
                  }}
                >
                  {cources.capacity}
                </span>
              </h3>

              <Typography variant="body2" color="text.secondary"></Typography>
            </CardContent>

            {authContext.isAuth ? <div className={AllCourcesStyle.detail}>
              {isInCart(state, cources._id) ? (
                <ButtonError
                onClick={() =>
                  dispatch({ type: "REMOVE_ITEM", payload: cources })}
                >
               
                  حذف از سبد
                </ButtonError>
              ) : (
                <Button
                onClick={() =>
                  dispatch({ type: "ADD_ITEM", payload: cources })}
                >
                  افزودن به سبد
                </Button>
              )}
              <Link to={`/cources/${cources._id}`}>بیشتر...</Link>
            </div> : <div className={AllCourcesStyle.detail}>
              
             
             
                <Button
                onClick={() =>navigate('./Login')
                 }
                >
                  ثبت نام
                </Button>
              
              <Link to={`/cources/${cources._id}`}>بیشتر...</Link>
            </div>}
          </Card>
        </div>
      ))}
    </div>: <h3 style={{marginTop:"100px"}}><Link style={{ fontSize:"22px"}} to='/Login'>لطفا وارد حسابتان شوید</Link></h3>}

    </>
  );
};

export default AllCources;
